import { FIELD_TYPES } from "constants/template-field-type";
import HubspotContactFormFields from "segments/desktop/core-components/hubspot-contact-form/fields-config";
import LogosTitleFieldsConfig from "segments/desktop/logos/components/logos-title/fields-config";
import LogosFieldsConfig from "segments/desktop/core-components/logos/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Hubspot With Bullets Side By Side",
  fields: {
    ...HubspotContactFormFields,
    title: {
      type: FIELD_TYPES.TEXT,
      label: "Title",
      translatable: true
    },
    benefits: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Benefits",
      maxLimit: 3,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          icon: { type: FIELD_TYPES.GALLERY, label: "Icon" },
          title: { type: FIELD_TYPES.TEXT, label: "Title", translatable: true },
          description: { type: FIELD_TYPES.TEXT, label: "Description", translatable: true }
        }
      }
    },
    logosTitle: {
      type: FIELD_TYPES.NESTED,
      label: "Logos title",
      fields: LogosTitleFieldsConfig
    },
    logos: {
      type: FIELD_TYPES.NESTED,
      label: "Logos",
      fields: LogosFieldsConfig
    }
  }
};
